import { render, staticRenderFns } from "./multi-drug-rapid-test-cup_pc.vue?vue&type=template&id=3299921e&scoped=true&"
import script from "./multi-drug-rapid-test-cup_pc.vue?vue&type=script&lang=js&"
export * from "./multi-drug-rapid-test-cup_pc.vue?vue&type=script&lang=js&"
import style0 from "./multi-drug-rapid-test-cup_pc.vue?vue&type=style&index=0&id=3299921e&scoped=true&lang=less&"
import style1 from "./multi-drug-rapid-test-cup_pc.vue?vue&type=style&index=1&id=3299921e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299921e",
  null
  
)

export default component.exports